import { Button, Flex, Text, Icon, useColorModeValue } from '@chakra-ui/react';
import { useRole } from 'contexts/RoleContext';

const RoleToggleItem = ({ title, value, icon, description }) => {
  const { selectedRole, toggleRole } = useRole();
  const isSelected = selectedRole === value;
  const inactiveBorderColor = useColorModeValue('gray.200', 'whiteAlpha.300');
  const hoverColor = useColorModeValue('blue.50', 'whiteAlpha.200');
  const selectedBg = useColorModeValue('blue.50', 'whiteAlpha.250');
  const unselectedBg = useColorModeValue('white', 'whiteAlpha.100');
  const titleColor = useColorModeValue('navy.700', 'white');
  const descriptionColor = useColorModeValue('gray.600', 'gray.300');
  const inactiveIconColor = useColorModeValue('navy.500', 'gray.200');
  const borderColor = isSelected ? 'blue.400' : inactiveBorderColor;
  const bg = isSelected ? selectedBg : unselectedBg;
  const iconColor = isSelected ? 'blue.400' : inactiveIconColor;

  return (
    <Flex flex="1">
      <Button
        type="button"
        borderWidth={isSelected ? 2 : 1}
        borderColor={borderColor} 
        bg={bg}
        h={{ base: 'auto', md: 180 }}
        w="100%"
        minH={{ base: '110px', md: '180px' }}
        flexDirection={{ base: 'row', md: 'column' }}
        justifyContent={{ base: 'flex-start', md: 'center' }}
        alignItems={{ base: 'flex-start', md: 'center' }}
        onClick={() => { toggleRole(value); }}
        overflow="hidden"
        textAlign={{ base: 'left', md: 'center' }}
        whiteSpace="normal"
        wordBreak="break-word"
        p={{ base: 4, md: 5 }}
        gap={{ base: 3, md: 2 }}
        transition="all 0.2s ease"
        borderRadius="20px"
        boxShadow={isSelected ? '0 14px 32px rgba(66, 153, 225, 0.22)' : 'none'}
        aria-pressed={isSelected}
        aria-label={title}
        _hover={{
          bg: hoverColor,
          borderColor: 'blue.300',
          transform: 'translateY(-1px)',
          boxShadow: 'md',
        }}
        _active={{ transform: 'translateY(0)' }}
      >
        <Icon as={icon} boxSize={{ base: 6, md: 9 }} color={iconColor} mt={{ base: 1, md: 0 }} />
        <Flex direction="column" align={{ base: 'flex-start', md: 'center' }}>
          <Text fontWeight="700" mb={1} color={titleColor}>
            {title}
          </Text>
          <Text fontSize={{ base: 'xs', md: 'sm' }} color={descriptionColor}>
            {description}
          </Text>
        </Flex>
      </Button>
    </Flex>
  );
};

export default RoleToggleItem;
